var render = function render(){
  var _vm$projectData, _vm$projectData$compa, _vm$projectData2, _vm$projectData3, _vm$projectData4, _vm$projectData5, _vm$projectData6, _vm$projectData6$cont, _vm$projectData7, _vm$projectData7$term, _vm$projectData8, _vm$projectData9, _vm$projectData10, _vm$projectData11, _vm$projectData12, _vm$projectData13, _vm$projectData13$car, _vm$projectData14, _vm$projectData15;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "real-shipment"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "float-right mr-1",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openSlideFormRealShipment('ADD', null, null);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("   ADD REAL SHIPMENT ")])], 1)], 1), _vm._m(0), _c('div', {
    staticClass: "info-grid px-3"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Company Name")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData = _vm.projectData) === null || _vm$projectData === void 0 ? void 0 : (_vm$projectData$compa = _vm$projectData.company) === null || _vm$projectData$compa === void 0 ? void 0 : _vm$projectData$compa.company))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Fleet Ownership")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData2 = _vm.projectData) === null || _vm$projectData2 === void 0 ? void 0 : _vm$projectData2.fleet_ownership))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Fleet Type")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value chips"
  }, _vm._l((_vm$projectData3 = _vm.projectData) === null || _vm$projectData3 === void 0 ? void 0 : _vm$projectData3.fleet_type_ids, function (item, index) {
    return _c('span', {
      key: index,
      staticClass: "chip"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.text) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Period")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(" " + _vm._s((_vm$projectData4 = _vm.projectData) !== null && _vm$projectData4 !== void 0 && _vm$projectData4.period && ((_vm$projectData5 = _vm.projectData) === null || _vm$projectData5 === void 0 ? void 0 : _vm$projectData5.period.length) === 2 ? "".concat(_vm.moment(_vm.projectData.period[0]).format('DD/MM/YYYY'), " - ").concat(_vm.moment(_vm.projectData.period[1]).format('DD/MM/YYYY')) : '-') + " ")])]), _vm._m(1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Contract Type")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_c('div', [_vm._v(_vm._s((_vm$projectData6 = _vm.projectData) === null || _vm$projectData6 === void 0 ? void 0 : (_vm$projectData6$cont = _vm$projectData6.contract_type) === null || _vm$projectData6$cont === void 0 ? void 0 : _vm$projectData6$cont.name))]), _vm._m(2)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Term")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData7 = _vm.projectData) === null || _vm$projectData7 === void 0 ? void 0 : (_vm$projectData7$term = _vm$projectData7.terms) === null || _vm$projectData7$term === void 0 ? void 0 : _vm$projectData7$term.code))])])]), _c('div', {
    staticClass: "right"
  }, [_vm._m(3), _vm._m(4), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Distance")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData8 = _vm.projectData) === null || _vm$projectData8 === void 0 ? void 0 : _vm$projectData8.distance))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Laycan")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(" " + _vm._s((_vm$projectData9 = _vm.projectData) !== null && _vm$projectData9 !== void 0 && _vm$projectData9.laycan && ((_vm$projectData10 = _vm.projectData) === null || _vm$projectData10 === void 0 ? void 0 : _vm$projectData10.laycan.length) === 2 ? "".concat(_vm.moment((_vm$projectData11 = _vm.projectData) === null || _vm$projectData11 === void 0 ? void 0 : _vm$projectData11.laycan[0]).format('DD/MM/YYYY'), " - ").concat(_vm.moment((_vm$projectData12 = _vm.projectData) === null || _vm$projectData12 === void 0 ? void 0 : _vm$projectData12.laycan[1]).format('DD/MM/YYYY')) : '-') + " ")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Cargo Type")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData13 = _vm.projectData) === null || _vm$projectData13 === void 0 ? void 0 : (_vm$projectData13$car = _vm$projectData13.cargo_type) === null || _vm$projectData13$car === void 0 ? void 0 : _vm$projectData13$car.name))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Total Plan QTY")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData14 = _vm.projectData) === null || _vm$projectData14 === void 0 ? void 0 : _vm$projectData14.total_quantity))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Remarks")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData15 = _vm.projectData) === null || _vm$projectData15 === void 0 ? void 0 : _vm$projectData15.remarks))])])])])], 1), _c('section', {
    staticClass: "section"
  }, [_vm._m(5), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "table-custom"
  }, [_vm._m(6), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "check"
  }, [_c('b-form-checkbox', {
    attrs: {
      "checked": ""
    }
  })], 1), _vm._m(7), _vm._m(8), _c('td', [_vm._v("COAL")]), _c('td', [_vm._v("10.000 MT")]), _c('td', [_vm._v("PLAN")]), _c('td', [_c('b-button', {
    staticClass: "btn-desc",
    attrs: {
      "size": "sm",
      "variant": "primary"
    }
  }, [_vm._v(" Description ")])], 1), _c('td', [_c('b-button', {
    staticClass: "btn-remarks",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_vm._v(" Remarks ")])], 1)]), _c('tr', [_c('td', {
    staticClass: "check"
  }, [_c('b-form-checkbox', {
    attrs: {
      "checked": ""
    }
  })], 1), _vm._m(9), _vm._m(10), _c('td', [_vm._v("COAL")]), _c('td', [_vm._v("12.000 MT")]), _c('td', [_vm._v("PLAN")]), _c('td', [_c('b-button', {
    staticClass: "btn-desc",
    attrs: {
      "size": "sm",
      "variant": "primary"
    }
  }, [_vm._v(" Description ")])], 1), _c('td', [_c('b-button', {
    staticClass: "btn-remarks",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_vm._v(" Remarks ")])], 1)])])]), _c('b-sidebar', {
    attrs: {
      "id": "slideFormRealShipment",
      "title": "Create Real Shipment",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _vm$projectData16;
        var hide = _ref.hide;
        return [_c('SlideFormRealShipment', {
          attrs: {
            "closeSlideFormRealShipment": _vm.closeSlideFormRealShipment,
            "refreshData": _vm.fetchRealShipment,
            "optionsFleets": _vm.optionsFleets,
            "projectId": (_vm$projectData16 = _vm.projectData) === null || _vm$projectData16 === void 0 ? void 0 : _vm$projectData16.id,
            "action": _vm.action,
            "detailRealShipment": _vm.detailRealShipment,
            "showVehicleName": _vm.showVehicleName
          }
        })];
      }
    }]),
    model: {
      value: _vm.slideFormRealShipment,
      callback: function callback($$v) {
        _vm.slideFormRealShipment = $$v;
      },
      expression: "slideFormRealShipment"
    }
  })], 1)]), _c('section', {
    staticClass: "section"
  }, [_vm._m(11), _c('div', {
    staticClass: "date-input"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "value": "01/01/2025 - 31/12/2025",
      "readonly": ""
    }
  }), _c('b-input-group-append', [_c('b-input-group-text', [_c('i', {
    staticClass: "fa fa-calendar"
  })])], 1)], 1)], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("PROJECT INFO")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Shipment Plan Number")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v("ownship-sfc-2509-0003")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "badge-info"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" This type using SPAL ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Port of Loading")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v("Bengalon")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Port of Discharging")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v("Paiton")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("DETAIL SHIPMENT PLAN")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "check"
  }), _c('th', [_vm._v("Number Detail Plan")]), _c('th', [_vm._v("Fleet")]), _c('th', [_vm._v("Cargo Type")]), _c('th', [_vm._v("Plan QTY")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Description")]), _c('th', [_vm._v("Remarks")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("ownship-tc-2510-0004-0001")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "badge-fleet"
  }, [_vm._v("TB. ETI 301")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("ownship-tc-2510-0004-0002")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "badge-fleet"
  }, [_vm._v("TB. ETI 302")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("FLEET OPERATIONS")])]);

}]

export { render, staticRenderFns }